import React, { useEffect, useState } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import PlotCard from "../components/PlotCard";
import { getLayoutById, fetchPublicPlots } from "../services/api";
import { stripHtml } from "../utils/text";

const LayoutPlots = () => {
  const { id } = useParams();
  const location = useLocation();
  const [layout, setLayout] = useState(location.state?.layout || null);
  const [loadingLayout, setLoadingLayout] = useState(!location.state?.layout);

  const [plots, setPlots] = useState([]);
  const [loadingPlots, setLoadingPlots] = useState(true);

  useEffect(() => {
    const loadLayout = async () => {
      if (!id) return;
      if (layout) return;
      setLoadingLayout(true);
      try {
        const res = await getLayoutById(id);
        const data = res?.payload || res;
        setLayout(data);
      } catch (e) {
        console.error("Failed to load layout", e);
      } finally {
        setLoadingLayout(false);
      }
    };
    loadLayout();
  }, [id, layout]);

  useEffect(() => {
    const loadPlots = async () => {
      if (!id) return;
      setLoadingPlots(true);
      try {
        const res = await fetchPublicPlots(0, 100, { layoutId: id });
        const page = res?.payload?.page || [];
        setPlots(Array.isArray(page) ? page : []);
      } catch (e) {
        console.error("Failed to load plots for layout", e);
        setPlots([]);
      } finally {
        setLoadingPlots(false);
      }
    };
    loadPlots();
  }, [id]);

  return (
    <>
      <Helmet>
        <title>{layout?.name ? `${layout.name} - All Plots` : "Layout Plots"}</title>
        <meta name="description" content={layout?.description ? stripHtml(layout.description) : "All plots for layout"} />
      </Helmet>

      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('/assets/img/main/m1.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">{layout?.name || "Layout Plots"}</h1>
            <ul className="breadcumb-menu">
              <li>
                <Link to="/layouts">Layouts</Link>
              </li>
              {layout?.name && <li>{layout.name}</li>}
              <li>All Plots</li>
            </ul>
          </div>
        </div>
      </div>

      <section className="space-top space-extra-bottom">
        <div className="container">
          {loadingPlots ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : plots.length === 0 ? (
            <p className="text-muted">No plots found for this layout.</p>
          ) : (
            <div className="row gy-4">
              {plots.map((plot) => (
                <PlotCard key={plot.id} plot={plot} />
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default LayoutPlots;
